import { render } from "./PendingDeviceRequestHost.vue?vue&type=template&id=208ff649&scoped=true"
import script from "./PendingDeviceRequestHost.vue?vue&type=script&lang=js"
export * from "./PendingDeviceRequestHost.vue?vue&type=script&lang=js"

import "./PendingDeviceRequestHost.vue?vue&type=style&index=0&id=208ff649&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208ff649"]])

export default __exports__